import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";
import { cn } from "@/lib/utils";
import { Inbox, LayoutDashboard, LogOut, Package, ShoppingCart, Store } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

	const navItems = [
		{ label: "Dashboard", href: "/", icon: LayoutDashboard },
		{ label: "Stores", href: "/stores", icon: Store },
		{ label: "Messages", href: "/messages", icon: Inbox },
		{ label: "Orders", href: "/orders", icon: ShoppingCart },
		{ label: "Account", href: "/account", icon: Package },
	];

export function Sidebar() {
	const location = useLocation();
	const { signOut } = useAuth();

	return (
		<aside className="flex h-screen w-64 flex-col border-r bg-card">
			<div className="flex h-16 items-center gap-2 border-b px-6">
				<Package className="h-6 w-6 text-primary" />
				<span className="text-lg font-bold">Sunmerce</span>
			</div>

			<nav className="flex-1 space-y-1 p-4">
				{navItems.map((item) => {
					const isActive =
						item.href === "/" ? location.pathname === "/" : location.pathname.startsWith(item.href);
					return (
						<Link
							key={item.href}
							to={item.href}
							className={cn(
								"flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
								isActive
									? "bg-primary/10 text-primary"
									: "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
							)}
						>
							<item.icon className="h-4 w-4" />
							{item.label}
						</Link>
					);
				})}
			</nav>

			<div className="border-t p-4">
				<Button
					variant="ghost"
					className="w-full justify-start gap-3 text-muted-foreground"
					onClick={() => signOut()}
				>
					<LogOut className="h-4 w-4" />
					Sign Out
				</Button>
			</div>
		</aside>
	);
}
